(function () {
  'use strict';

  function setup(container) {
    var rangeMax = parseFloat(container.dataset.rangeMax) || 0;
    var minSlider = container.querySelector('[data-qala-price-slider-min]');
    var maxSlider = container.querySelector('[data-qala-price-slider-max]');
    var rangeFill = container.querySelector('[data-qala-price-range]');
    var wrap = container.closest('price-range') || container.parentElement.parentElement || container.parentElement;
    var minText = wrap.querySelector('[data-qala-price-text-min]');
    var maxText = wrap.querySelector('[data-qala-price-text-max]');
    if (!minSlider || !maxSlider || rangeMax <= 0) return;

    // Range inputs can fire `input` dozens of times per second while
    // dragging. Writing to style.left/right on every single tick forces a
    // synchronous layout recalculation each time, which is what makes the
    // slider feel laggy/janky — batching to one write per animation frame
    // caps it to the display's refresh rate and keeps dragging smooth.
    function paintFillNow() {
      var minVal = parseFloat(minSlider.value) || 0;
      var maxVal = parseFloat(maxSlider.value) || 0;
      var minPct = Math.max(0, Math.min(100, (minVal / rangeMax) * 100));
      var maxPct = Math.max(0, Math.min(100, (maxVal / rangeMax) * 100));
      rangeFill.style.left = minPct + '%';
      rangeFill.style.right = (100 - maxPct) + '%';
    }

    var rafPending = false;
    function updateFill() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        paintFillNow();
      });
    }

    function fireTextInput(el) {
      if (!el) return;
      var evt = new Event('change', { bubbles: true });
      el.dispatchEvent(evt);
    }

    minSlider.addEventListener('input', function () {
      if (parseFloat(minSlider.value) > parseFloat(maxSlider.value)) {
        minSlider.value = maxSlider.value;
      }
      if (minText) minText.value = minSlider.value;
      updateFill();
    });
    minSlider.addEventListener('change', function () {
      fireTextInput(minText);
    });

    maxSlider.addEventListener('input', function () {
      if (parseFloat(maxSlider.value) < parseFloat(minSlider.value)) {
        maxSlider.value = minSlider.value;
      }
      if (maxText) maxText.value = maxSlider.value;
      updateFill();
    });
    maxSlider.addEventListener('change', function () {
      fireTextInput(maxText);
    });

    // The reverse direction was missing entirely: typing a number into the
    // "From"/"To" boxes updated the text field (and, via Dawn's own facet
    // JS, eventually the product results) but never touched the slider
    // input's own value — so the handle stayed wherever it last was
    // (often collapsed onto the other handle at 0%), looking broken/gone
    // even though the filter itself was applied correctly.
    function syncSliderFromText(textEl, sliderEl, otherSliderEl, isMin) {
      if (!textEl) return;
      textEl.addEventListener('change', function () {
        var parsed = parseFloat(String(textEl.value).replace(/,/g, ''));
        if (isNaN(parsed)) return;
        parsed = Math.max(0, Math.min(rangeMax, parsed));
        if (isMin && parsed > parseFloat(otherSliderEl.value)) {
          parsed = parseFloat(otherSliderEl.value);
        }
        if (!isMin && parsed < parseFloat(otherSliderEl.value)) {
          parsed = parseFloat(otherSliderEl.value);
        }
        sliderEl.value = parsed;
        // A discrete, one-off change (not a rapid drag) — paint immediately
        // rather than deferring to requestAnimationFrame, which browsers
        // can suspend indefinitely on a backgrounded/inactive tab.
        paintFillNow();
      });
    }
    syncSliderFromText(minText, minSlider, maxSlider, true);
    syncSliderFromText(maxText, maxSlider, minSlider, false);

    // Initial paint should be immediate, not deferred a frame.
    paintFillNow();
  }

  function init() {
    document.querySelectorAll('[data-qala-price-slider]').forEach(function (el) {
      if (el.dataset.qalaInitialized) return;
      el.dataset.qalaInitialized = 'true';
      setup(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn's facet AJAX filtering replaces facet containers via innerHTML
  // whenever a *different* filter changes, which drops this script's event
  // listeners silently (injected <script> tags never re-execute). Re-scan
  // for fresh, uninitialized sliders whenever the facets DOM changes instead
  // of relying on a custom event the theme doesn't actually dispatch.
  var observeTargets = ['#FacetFiltersForm', '#FacetFiltersFormMobile'];
  function attachObserver() {
    observeTargets.forEach(function (selector) {
      var target = document.querySelector(selector);
      if (!target || target.__qalaPriceObserved) return;
      target.__qalaPriceObserved = true;
      var mo = new MutationObserver(function () {
        init();
      });
      mo.observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();
